import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, ref } from 'vue';

import DropdownPlus from '@/components/dropdownPlus/index.vue';
import type { TLocale } from '@/config/lang';
import { useLangStore } from '@/store/langStore';

import type { IDropdownItem } from '../dropdown/Dropdown.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useLangStore();

const browserLng = store.langOptions.find((item) => item.value?.includes(navigator?.language));
const englishLng = store.langOptions.find((item) => item.value === 'en-US');
const defaultLng = browserLng ?? englishLng ?? store.langOptions[0];

const selectedLanguage = computed(() => {
  const storedLocale = localStorage.getItem('locale');

  const finalLng = store.langOptions.find((item) => item.value === storedLocale) ?? defaultLng;

  // 更新 localStorage 内数据，避免子应用切换时，语言选项和页面实际语言不一致
  localStorage.setItem('locale', finalLng?.value);
  localStorage.setItem('localeName', finalLng?.label);

  return finalLng?.value ?? '';
});

const displayLanguageName = computed(() => {
  let currentRegion = store.langOptions.find((v: any) => v.value === selectedLanguage.value);
  return currentRegion?.label || localStorage.getItem('localeName');
});

const handleChange = (newRegion: IDropdownItem<string>) => {
  store.setLang(newRegion.value as TLocale);
  localStorage.setItem('locale', newRegion.value);
  localStorage.setItem('localeName', newRegion.label);
  window?.xmot?.('click', { tip: '310.543.0.1.41552' });
  window.location.reload();
};

onMounted(() => {
  const hasLocalRegion = localStorage.getItem('locale');
  if (!hasLocalRegion) {
    localStorage.setItem('locale', defaultLng?.value);
    localStorage.setItem('localeName', defaultLng?.label);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DropdownPlus, {
    modelValue: selectedLanguage.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLanguage).value = $event)),
    options: _unref(store).langOptions,
    onChange: handleChange
  }, null, 8, ["modelValue", "options"]))
}
}

})